const {
  validateDeck,
  BANNED_CARDS,
  BANNED_BATTLEFIELDS,
  BANNED_2V2_LEGENDS,
  UNIQUE_CARDS,
} = require('./deckValidation');
const { calculateDeckStats } = require('./stats');
const {
  DOMAINS,
  getCardTypes,
  cardHasType,
  getCardDomains,
  getLegendTags,
  cardHasChampionTag,
  cardCost,
  isInDomainIdentity,
} = require('./helpers');

module.exports = {
  validateDeck,
  calculateDeckStats,
  BANNED_CARDS,
  BANNED_BATTLEFIELDS,
  BANNED_2V2_LEGENDS,
  UNIQUE_CARDS,
  DOMAINS,
  getCardTypes,
  cardHasType,
  getCardDomains,
  getLegendTags,
  cardHasChampionTag,
  cardCost,
  isInDomainIdentity,
};
